export default "__VITE_ASSET__421bf275__"